export enum VehicleType {
  PKW = "pkw",
  BUS = "bus"
}

export function castVehicleTypeEnum(value: any): string {
  switch (value) {
    case VehicleType.PKW:
      return 'VEHICLES.TYPES.PKW'
    case VehicleType.BUS:
      return 'VEHICLES.TYPES.BUS'
    default:
      return '-'
  }
}
